<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Reason</span>

              <!-- <v-spacer></v-spacer>
              <v-btn fab x-small @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn> -->
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="reasons"
                      label="Select Reason*"
                      :rules="rules.required"
                      item-text="label"
                      item-value="value"
                      v-model="form.reason"
                    ></v-select>
                  </v-col>

                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-textarea
                      outlined
                      name="input-7-4"
                      label="Message"
                      v-model="form.reason"
                      :rules="rules.required"
                    ></v-textarea>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>

              <v-btn @click.native="cancel" text> Cancel </v-btn>
              <v-btn @click.native="agree" color="primary"> Proceed </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>

    <!-- <v-snackbar v-model="snackbar">
      {{ responseMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      // snackbar: false,
      // responseMessage: "",
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        reason: "",
      },

      reasons: [],
      // currentData: {}
      // form: {
      //   to: "",
      //   text: "",
      //   id: 0,
      //   UserId: this.$store.getters.getUsername,
      // },
    };
  },
  // props: ["data", "dialog", "apiUrl", "title"],

  methods: {
    async open() {
      this.dialog = true;
      // this.currentData = data;
      this.getReasons();
      this.form.reason = "";
      // this.form.dealerName = data.companyName;
      // this.title = title;
      // this.message = message;
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve({
        status: true,
        reason: this.form.reason,
      });
      this.dialog = false;
    },
    cancel() {
      this.resolve({
        status: false,
      });
      this.dialog = false;
    },
    // closeDialog() {
    //   this.$emit("close", false);
    // },

    async getReasons() {
      await this.$api
        // .post("ZEDSMS", this.form)
        .get("/online/cod/reasons")
        .then((response) => {
          console.log(response);
          const res = response.data;

          this.reasons = res.data.codReasons;
        })
        .catch((e) => {
          console.log(e);
          // this.loadingBtn = false;
        });
    },
  },

  watch: {},
};
</script>
